/**
 * Assessment and Activity Status Constants
 * Centralized definition of all status codes used throughout the application
 */

export const ASSESSMENT_STATUS = {
	LOCKED: 'Locked',
	OPEN: 'Open',
	IN_PROGRESS: 'InProgress',
	COMPLETED: 'Completed',
	READY_FOR_REVIEW: 'ReadyForReview',
	RE_ATTEMPT: 'ReAttempt',
	NOT_STARTED: 'NotStarted',
} as const;

export const ACTIVITY_STATUS = {
	LOCKED: 'Locked',
	OPEN: 'Open',
	IN_PROGRESS: 'InProgress',
	COMPLETED: 'Completed',
	READY_FOR_REVIEW: 'ReadyForReview',
	RE_ATTEMPT: 'ReAttempt',
	NOT_STARTED: 'NotStarted'
} as const;

// Type definitions for better type safety
export type AssessmentStatusType = typeof ASSESSMENT_STATUS[keyof typeof ASSESSMENT_STATUS];
export type ActivityStatusType = typeof ACTIVITY_STATUS[keyof typeof ACTIVITY_STATUS];

// Helper functions for status checking
export const isCompletedStatus = (status: string): boolean =>
	status === ASSESSMENT_STATUS.COMPLETED;

export const isActiveStatus = (status: string): boolean =>
	([ASSESSMENT_STATUS.IN_PROGRESS, ASSESSMENT_STATUS.READY_FOR_REVIEW] as AssessmentStatusType[]).includes(status as AssessmentStatusType);

export const isReviewableStatus = (status: string): boolean =>
	([ASSESSMENT_STATUS.COMPLETED, ASSESSMENT_STATUS.READY_FOR_REVIEW, ASSESSMENT_STATUS.RE_ATTEMPT] as readonly AssessmentStatusType[]).includes(status as AssessmentStatusType);